angular.module("accordionIndividualPerson.components", [])
    .component("accordionIndividualPerson", {
        templateUrl: "ng/components/accordionIndividualPerson/accordionIndividualPerson.view.html",
        bindings: {
            indexValue: '<',
            model: '<',
            individualsOk: '&',
            individualsNotOk: '&',
            appIlTransaction: '<',
            isDigital: '<',
            financialModel: '=',
            exportInfoRest: '&',
            recallRest: '<',
            viewName: '<',
            snapshot: '<',
            changedSignatureMethod: '<',
            portalRunned: '<',
            recallRestGetLinkPerson: '<'

        },
        controllerAs: 'individualPersonCtrl',
        controller: function IndividualPerson(
            es6Factory,
            $rootScope,
            $modalService,
            $searchUserService,
            $configService,
            $timeout,
            $typeDomainService,
            validationService,
            verifyUniqueService,
            Pf,
            RiUserF,
            $userService,
            $instantService,
            $financialApiService,
            $portalService,
            $simulationService,
            EnteRilascio,
            $workflowService
        ) {
            var self = this;

            self.es6Factory = es6Factory;

            self.$onInit = function () {
                self.nationsList = $rootScope.nazioniEstere.filter(x => {
                    return x.description != '086' && x.description != '139' && x.description != 'T86'
                })
                self.listOfDisabledUser = [];
                self.inPurgatory = [];
                self.supportModel = {
                    warrantyList: [],
                    elementToAdd: [],
                    enableConfButton: false,
                    numberOfWarranties: 0,
                    totalWarrantiesAmount: 0,
                    enableModal: false,
                    index: 0,
                    loaderRemove: []
                }
                self.$portalService = $portalService
                self.isDealer = false;
                self.filterTools = {
                    orderType: "",
                    orderColumnName: ""
                }

                self.dealerUser = {
                    identifier: null
                };
                dealerUser();
                self.today = moment(new Date()).format('DD/MM/YYYY');
                self.riUserF = RiUserF.build();
                self.enableModal = false;
                self.enableModalCensus = false;
                self.warnings = {
                    errorMsg: {
                        cf: ''
                    }
                }
                self.user = {}
                self.mapComuni = $rootScope.comuniMap;
                self.mapComuniNsilSoppressi = $rootScope.mapComuniSoppressi;
                self.riViewObj = {};
                self.searchObj = {
                    pfcf: '',
                    ndg: ''
                };
                self.citiesList = {
                    sedeLegale: [],
                    sedeConsegna: [],
                    fatturazione: [],
                    datiNascita: [],
                    residenza: []
                };
                self.capList = {
                    sedeLegale: [],
                    sedeConsegna: [],
                    fatturazione: [],
                    residenza: []
                };
                self.loading = {};
                self.dropdown = {
                    entiRilascio: [],
                    listaProvince: []
                };
                self.validationObj = {
                    documentDate: {
                        disabledDays: [0],
                        disabledDates: [
                            '01-01',
                            '06-01',
                            '25-04',
                            '01-05',
                            '02-06',
                            '15-08',
                            '01-11',
                            '08-12',
                            '25-12',
                            '26-12'
                        ]
                    },
                    regex: {
                        documentNumber: /.+/
                    }
                }
                self.raccoltaInfo = {
                    //numPreventivo: FactoryObj.simulationItem.id,
                    datiSocietari: {
                        sedeLegale: {},
                        sedeConsegna: {},
                        fatturazione: {},
                        //piva: FactoryObj.selectedUserG.identifier,
                        dataAvvioAttivita: '',
                        sae2: null,
                        rae2: null,
                        emailPec2: null
                    },
                    questionario: {},
                    autorizzazioneSDD: {},
                    privacy: {
                        downloaded: false,
                        documentoPrivacyFirmato: {},
                        moduleCode: "",
                        subscritionDate: null,
                        validityEndDate: null,
                        listaConsensi: [],
                        writeToNsil: false,
                        index: null
                    },
                    adeguataVerifica: {
                        mandatoFiduciario: self.model.adeguataVerifica.mandatoFiduciario || false
                    },
                    listaPf: [],
                    documentazioneContrattuale: []
                };

                self.listaProvince = self.mapComuni
                    .map(function (comune) {
                        return comune.sigla
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != ""
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem)
                    }, []);

                //Get Domains

                getListaEntiRilascio();

                getDocumentTypes();

                getEntiRilascio();

                self.checkOk();

                if (getWizardMap(self.financialModel.viewIndex) == "M17") {
                    self.isContractSignatureMap = true;
                } else {
                    self.isContractSignatureMap = false;
                }

                if (getWizardMap(self.financialModel.viewIndex) == "M15") {
                    self.isWarrantiesMap = true;

                    if (self.financialModel.leasingData.preventivo.garanzie.length > 0) {

                        self.supportModel.totalWarrantiesAmount = 0;
                        self.financialModel.leasingData.preventivo.garanzie.forEach(function (garanzia) {
                            self.supportModel.totalWarrantiesAmount =
                                parseFloat(self.supportModel.totalWarrantiesAmount) + parseFloat(garanzia.importoInizialeGaranzia);
                        });
                    }

                } else {
                    self.isWarrantiesMap = false;
                }

                if (self.model.riUserF.listaPf.length > 0 && !self.isContractSignatureMap && !self.isWarrantiesMap) {
                    self.riUserF.listaPf = self.model.riUserF.listaPf;
                    controlIfUserFromAdv(self.model.riUserF.listaPf);
                    searchOfusersDisabled(self.model.riUserF.listaPf);
                    checkIfUserNotRule();
                    return;
                } else if (!self.isContractSignatureMap && !self.isWarrantiesMap) {
                    getPfList();
                } else if (self.isContractSignatureMap && !self.isWarrantiesMap) {
                    if (self.snapshot) {
                        var loaderSigner = false;
                        getSignatureContract(loaderSigner, self.model.riUserF.listaPf);
                    } else {
                        var loaderSigner = true;
                        getSignatureContract(loaderSigner);
                    }
                } else if (self.isWarrantiesMap && !self.isContractSignatureMap) {

                    getLinkedPersonPractice();

                }

                if (self.isDigital) {
                    populateGuarSelectedList();
                }
            }

            self.$onChanges = function (changes) {
                if (changes.recallRest && changes.recallRest.currentValue != changes.recallRest.previousValue) {

                    var loaderSigner = false;

                    self.riUserF && self.riUserF.listaPf && getSignatureContract(loaderSigner, self.riUserF.listaPf);
                }
                if (changes.changedSignatureMethod && typeof changes.changedSignatureMethod.currentValue != "undefined") {
                    var loaderSigner = false;

                    self.riUserF && self.riUserF.listaPf && getSignatureContract(loaderSigner, self.riUserF.listaPf);
                    self.checkOk();
                }

                if (changes.recallRestGetLinkPerson && changes.recallRestGetLinkPerson.currentValue) {
                    var loaderSigner = false;
                    getSignatureContract(loaderSigner);
                }
            }
            /**
             * Domains
             */
            var getSignatureContract = function (loadSigners, persons) {
                self.searching = true;
                // show loader into section send to arc 
                $rootScope.$broadcast("componentLoader", {
                    action: "OPEN"
                });
                $simulationService.getLinkedPersonContract(self.financialModel.leasingData.id, loadSigners, persons, self.financialModel.monitor,
                    self.financialModel.leasingData.preventivo.firmaDigitale, self.financialModel.leasingData.preventivo.firmaDigitaleEsterna, self.financialModel.leasingData.preventivo.smallTicket, self.changedSignatureMethod)
                    .then(function (response) {
                        if (response.success) {
                            console.log(response);
                            self.financialModel.leasingData.preventivo.smallTicket = response.smallTicket;
                            self.exportInfoRest({
                                value: response
                            })
                            if (response.persons && response.persons.length) {
                                response.persons.forEach(user => {

                                    user.sesso = user.sesso && user.sesso.toLowerCase()
                                    if (user.isEstero) {
                                        var objectNation = self.nationsList
                                            .find(function (element) {
                                                return element.name.toUpperCase() == user.datiNascita.comune.toUpperCase();
                                            })
                                        if (!user.sesso) {

                                            user.sesso = new Date().getSeconds() % 2 == 0 ? 'm' : 'f';
                                        }
                                        user.cf = validationService.createCf(user.nome, user.cognome, user.datiNascita.data, user.sesso, objectNation.value);
                                    }
                                }
                                );

                                self.riUserF.listaPf = response.persons;
                                self.financialModel.financialCustomer.metadata.riUserF.listaPf = self.riUserF.listaPf;
                            }
                        }

                        self.searching = false;
                        self.checkOk();
                        // hide loader into section send to arc 
                        $rootScope.$broadcast("componentLoader", {
                            action: "CLOSE"
                        });
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.searching = false;
                        self.checkOk();
                        // hide loader into section send to arc 
                        $rootScope.$broadcast("componentLoader", {
                            action: "CLOSE"
                        });
                    })

            }

            var getPfList = function () {
                self.loading.loadingPfList = true;
                self.identifier = self.isDigital ? self.financialModel.financialCustomer.metadata.riUserG.cf : $configService.getUser().identifier;
                var ndg = self.isDigital ? self.financialModel.financialCustomer.metadata.riUserG.ndg : $configService.getUser().ndg;
                if (self.isDigital) {
                    $searchUserService
                        .getLinkedPersonDigital(self.identifier, ndg, self.financialModel.leasingData.id)
                        .then(function (response) {
                            var pfList = response.listAppCustomer
                            self.financialModel.leasingData.preventivo.smallTicket = response.smallTicket;
                            console.log('pf list: ', pfList);
                            if (self.isDigital) {
                                pfList && pfList.forEach(function (e) {
                                    if (e.metadata.riUserF) {
                                        Object.assign(e.metadata.riUserF, {
                                            'validCertificate': e.validCertificate
                                        });

                                        if (typeof e.metadata.riUserF.documento.enteRilascio == 'string') {
                                            e.metadata.riUserF.documento.enteRilascio = EnteRilascio.build({
                                                name: e.metadata.riUserF.documento.enteRilascio
                                            })
                                        }

                                    }
                                });

                            }

                            //take only the riUserF from each retrieved object
                            self.riUserF.listaPf = pfList && pfList
                                .map(function (pf) {
                                    if (pf.metadata.riUserF && pf.metadata.riUserF.cf) {
                                        return pf.metadata.riUserF
                                    } else {
                                        return
                                    }

                                })
                                .filter(function (element) {
                                    return element != undefined;
                                });
                            self.riUserF.listaPf.forEach(x => {
                                if (x.residenza && x.residenza.statoEsteso != undefined && x.residenza.statoEsteso.name) {
                                    x.residenza.stato = x.residenza.statoEsteso;
                                }
                            })
                            var riUserF = RiUserF.build(self.riUserF);
                            var listaPf = riUserF.listaPf;
                            var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                            listaPf = listaPf.map(function (pf) {
                                return Pf.build(pf).setDefaultPfValues(self.nationsList, comuni);
                            })
                            riUserF.listaPf = listaPf;

                            self.riUserF = riUserF;

                            if (!self.riUserF.listaPf[0]) {
                                self.riUserF.listaPf = []
                            }
                            self.riUserF.listaPf.forEach(function (pf) {
                                pf.isOk = pf.addToAdv
                            })

                            searchOfusersDisabled(self.riUserF.listaPf);
                            checkIfUserNotRule();
                            self.checkOk();

                        })
                        .catch(function (err) {
                            console.log(err);
                            $rootScope.$broadcast('addAlert', {
                                text: 'ERROR_TEC'
                            });
                            self.riUserF = RiUserF.build();
                        })
                        .finally(function () {
                            self.loading.loadingPfList = false;
                            self.checkOk();
                        })

                } else {
                    $searchUserService
                        .getLinkedPersonIL(self.identifier, ndg)
                        .then(function (pfList) {

                            console.log('pf list: ', pfList);
                            if (self.isDigital) {
                                pfList && pfList.forEach(function (e) {
                                    if (e.metadata.riUserF) {
                                        Object.assign(e.metadata.riUserF, {
                                            'validCertificate': e.validCertificate
                                        });
                                    }
                                });

                            }

                            //take only the riUserF from each retrieved object
                            self.riUserF.listaPf = pfList && pfList
                                .map(function (pf) {
                                    if (pf.metadata.riUserF && pf.metadata.riUserF.cf) {
                                        return pf.metadata.riUserF
                                    } else {
                                        return
                                    }

                                })
                                .filter(function (element) {
                                    return element != undefined;
                                });
                            var riUserF = RiUserF.build(self.riUserF);
                            var listaPf = riUserF.listaPf;
                            var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                            listaPf = listaPf.map(function (pf) {
                                return Pf.build(pf).setDefaultPfValues(self.nationsList, comuni);
                            })
                            riUserF.listaPf = listaPf;

                            self.riUserF = riUserF;

                            if (!self.riUserF.listaPf[0]) {
                                self.riUserF.listaPf = []
                            }

                            searchOfusersDisabled(self.riUserF.listaPf);

                        })
                        .catch(function (err) {
                            console.log(err);
                            $rootScope.$broadcast('addAlert', {
                                text: 'ERROR_TEC'
                            });
                            self.riUserF = RiUserF.build();
                        })
                        .finally(function () {
                            self.loading.loadingPfList = false;
                            self.checkOk();
                        })
                }
            }

            var getLinkedPersonPractice = function () {
                self.searching = true;

                $simulationService.getLinkedPersonPractice(self.financialModel)
                    .then(function (response) {
                        console.log(response);
                        self.labelProcessoAuto = response.labelProcessoAuto;
                        self.financialModel.financialCustomer.metadata.adeguataVerifica = response.adeguataVerifica;
                        self.financialModel.leasingData.preventivo.smallTicket = response.smallTicket;
                        self.exportInfoRest({
                            value: response
                        })
                        self.riUserF.listaPf = response.persons.map(x => {
                            var pf = Pf.build(x);
                            if (!!pf.datiNascita.stato && !!!pf.datiNascita.stato.value && !!pf.datiNascita.stato.name) {
                                pf.datiNascita.stato = self.nationsList.find(nation => x.datiNascita.stato.name.toUpperCase() == nation.name.toUpperCase());
                            }
                            if (pf.isEstero) {
                                pf.idEstero = validationService.createCf(x.nome, x.cognome, x.datiNascita.data, x.sesso, pf.datiNascita.stato.value);
                            }
                            return pf;
                        })
                        self.model.riUserF.listaPf = self.riUserF.listaPf;
                        self.searching = false;
                        searchOfusersDisabled(self.riUserF.listaPf)
                        checkIfUserNotRule();
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.searching = false;
                    })

            }

            var getDocumentTypes = function () {
                $typeDomainService
                    .getDomainSet('RI_DROPDOWN_DOMAINS', 'DOCUMENT_TYPE')
                    .then(function (response) {
                        console.log('pf list: ', response && response.domainList);
                        response.domainList
                            .forEach(function (tipoDocumento) {
                                var order = 0;
                                switch (tipoDocumento.value) {
                                    case 'CAE':
                                        order = 40;
                                        break;
                                    case 'CAI':
                                        order = 10;
                                        break;
                                    case 'CIE':
                                        order = 20;
                                        break;
                                    case 'NCE':
                                        order = 30;
                                        break;
                                    case 'PAM':
                                        order = 50;
                                        break;
                                    case 'PAS':
                                        order = 80;
                                        break;
                                    case 'PAT':
                                        order = 60;
                                        break;
                                    case 'UCO':
                                        order = 70;
                                        break;

                                    default:
                                        break;
                                }
                                tipoDocumento.order = order;
                            })
                        self.dropdown.tipiDocumento = response.domainList;

                    })
                    .catch(function (err) {
                        //no results
                        self.raccoltaInfo.listaPf = [];
                        console.log(err);
                    })
            }

            var getEntiRilascio = function () {
                self.loading.entiRilascio = true;

                $typeDomainService
                    .getDomainSet('RI_DROPDOWN_DOMAINS', 'DOCUMENT_ISSUER')
                    .then(function (enti) {

                        console.log('pf list: ', enti);

                        self.dropdown.entiRilascio = enti.domainList;


                    })
                    .catch(function (err) {
                        console.log(err);
                    })
                    .finally(function () {
                        self.loading.entiRilascio = false;
                    })
            }

            self.canAddPfToList = function (pf) {
                var alreadyAdded =
                    self.riUserF &&
                    self.riUserF.listaPf &&
                    self.riUserF.listaPf.find(function (pff) {
                        return pff.cf == pf.cf
                    });


                return !alreadyAdded && (self.tempPerson.firmatario.selected ||
                    self.tempPerson.titolare.selected ||
                    self.tempPerson.garante.selected);
            }

            self.addPfToList = function (pf) {
                var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                if (!pf.isEstero) {

                    self.riUserF.addPf(Pf.build(pf).setDefaultPfValues(self.nationsList, comuni));
                    self.riUserF = RiUserF.build(self.riUserF);
                } else {
                    self.riUserF.addPf(Pf.build(pf));
                    self.riUserF = RiUserF.build(self.riUserF);
                }
                self.cleanUserFound();
                self.model.riUserF = self.riUserF;
                //self.changed(pf);
                self.checkOk();
                var tempUser = [pf]
                searchOfusersDisabled(tempUser, true);
            }

            self.cleanUserFound = function () {
                self.tempPerson = {};
                self.PFresultsShown = false;
                self.searchObj.pfcf = "";
                self.searchObj.ndg = "";
            }

            self.checkMandato = function () {
                self.raccoltaInfo.adeguataVerifica.mandatoFiduciario = !self.raccoltaInfo.adeguataVerifica.mandatoFiduciario;
                self.model.adeguataVerifica.mandatoFiduciario = self.raccoltaInfo.adeguataVerifica.mandatoFiduciario;
                self.checkOk();
            }

            self.searchPF = function () {
                self.searching = true;
                self.openSectionUpgradePf = false;
                if (self.userAlreadyAdded(self.searchObj.pfcf.toUpperCase())) {
                    return
                }

                self.PFresultsShown = true;
                $searchUserService
                    .getCustomerFByNsil(self.searchObj.pfcf.toUpperCase(), self.financialModel.leasingData.id)
                    .then(function (pf) {

                        if (!pf || !pf.metadata || !pf.metadata.riUserF) {

                            console.log('Ora devi dare la possibilità di censire la nuova persona');
                            var data = {
                                cf: self.searchObj.pfcf.toUpperCase(),
                                prospect: true
                            }
                            self.tempPerson = Pf.build(data);
                        } else {

                            //elimino le informazioni sul campo titolare o firmatario se presenti
                            //così da obbligare alla selezione del ruolo relativo della persona cercata
                            if (pf.metadata.riUserF.documento && typeof pf.metadata.riUserF.documento.enteRilascio == 'string') {
                                pf.metadata.riUserF.documento.enteRilascio = {
                                    name: pf.metadata.riUserF.documento.enteRilascio
                                }
                            }
                            pf.metadata.riUserF.validCertificate = pf.validCertificate;
                            self.tempPerson = Pf.build(pf.metadata.riUserF);
                        }

                        self.PFresultsShown = true;

                        self.documentFromNsil = null;
                        self.inPurgatory.push(self.tempPerson.cf);
                        var listOfUser = [self.tempPerson];
                        searchOfusersDisabled(listOfUser);
                        self.emptyTemp = false;

                    })
                    .catch(function (error) {
                        console.log('error', error);
                    })
                    .finally(function () {
                        self.searching = false;

                    })

            }
            self.savePfData = function (pf) {
                var fromTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var index = self.riUserF.listaPf.findIndex(function (el) {
                    return el.cf === self.currentPfCf
                });
                console.log("INSERTING self.currentPf - ", self.currentPf);
                self.raccoltaInfo.listaPf[index] = JSON.parse(JSON.stringify(self.currentPf));
                if (!fromTable) {
                    self.riViewObj.viewIndex = 1;
                }
                console.log(self.riUserF.listaPf[index]);
                $modalService.closeModal('documentoRiconoscimento');
            }

            self.check = function (el) {
                el.selected = !el.selected;
                if (self.isDigital) {
                    checkAllDataCompleted();
                    self.financialModel.financialCustomer.metadata.riUserF = self.riUserF;
                }
                checkIfUserNotRule();
                self.checkOk();
            }

            self.userAlreadyAdded = function (pf, checkNdg) {
                var result = false;
                if (checkNdg) {
                    result = self.riUserF &&
                        self.riUserF.listaPf &&
                        !!self.riUserF.listaPf.find(function (el) {
                            return el.ndg === pf;
                        });

                } else {
                    result = self.riUserF &&
                        self.riUserF.listaPf &&
                        !!self.riUserF.listaPf.find(function (el) {
                            return el.cf && el.cf.toUpperCase() === pf.toUpperCase();
                        });

                }
                if (result) {
                    $rootScope.$broadcast('addAlert', {
                        text: 'PF_ALREADY_ADDED'
                    });
                    self.cleanUserFound();
                }

                return result;


            }

            self.removePf = function (pf, index) {
                var input = {
                    parentId: self.isDigital ? self.financialModel.leasingData.id : self.appIlTransaction.id,
                    idUser: pf.cf

                }
                self.supportModel.loaderRemove[index] = true;
                self.disabledAllRemove = true;
                $instantService.deleteSubjectSelection(input)
                    .then(function (response) {
                        var index = self.riUserF.listaPf.findIndex(function (el) {
                            return el.cf === pf.cf
                        });
                        self.riUserF.listaPf.splice(index, 1);
                        self.model.riUserF = self.riUserF;
                        self.checkOk();
                        var tempUser = [pf];
                        searchOfusersDisabled(tempUser, true, true);
                        self.supportModel.loaderRemove[index] = false;
                        self.disabledAllRemove = false;



                    })
                    .catch(function (error) {
                        $rootScope.$broadcast('addAlert', {
                            text: 'ERROR_GENERIC'
                        });
                        self.checkOk();
                        self.supportModel.loaderRemove[index] = false;
                        self.disabledAllRemove = false;
                    });



            }

            self.isForeignCf = function (cf) {
                return cf && cf.substr(11, 1) == 'Z';
            }

            self.editPf = function (pf) {
                if (!pf.isEstero) {
                    var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                    pf = Pf.build(pf).setDefaultPfValues(self.nationsList, comuni);
                    pf.sesso = pf.sesso.toLowerCase();
                    self.user = pf;
                    var fromTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    pf.cf = pf.cf.toUpperCase();
                    self.currentPf = JSON.parse(JSON.stringify(pf));
                    //self.currentPf.documento.dataScadenza = self.getEndDate(self.currentPf.documento.dataRilascio);
                    console.log('currentPf: ', self.currentPf);

                    if (self.isForeignCf(self.currentPf.cf)) {
                        self.currentPf.datiNascita.provincia = 'EE';
                    }

                    self.currentPfCf = self.currentPf.cf;
                    if (pf.cf == self.dealerUser.identifier) {
                        self.isDealer = true;
                    } else {
                        self.isDealer = false;
                    }
                    if (!fromTable) {
                        self.riViewObj.viewIndex = 4;
                        $timeout(function () {
                            $modalService.openModal('censusPerson');
                            $("#footerInstant").css("z-index", "-1");
                            $('.financial-leasing__footer').css("z-index", "-1");
                        }, 100)
                        //$modalService.openModal('censusPerson');
                    } else {
                        self.openDocumentModal();
                    }
                    if (self.currentPf.cf && self.currentPf.documento.tipo) {
                        self.getNsilDocument(self.currentPf.documento.tipo, self.currentPf.cf);
                    }
                    console.log('currentPf: ', self.currentPf);

                    self.enableModal = true;
                } else {
                    self.user = pf;
                    self.disableButtonAddEstero = true;
                    self.enableModalPfEstero = true;
                    $timeout(function () {
                        $("#footerInstant").css("z-index", "-1");
                        $('.financial-leasing__footer').css("z-index", "-1");
                        $modalService.openModal("censusPfEstero");
                        self.disableButtonAddEstero = false;
                    }, 100)

                }
            }

            self.getCities = function (field, provincia) {
                var clearPf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (provincia && provincia != 'EE') {
                    self.citiesList[field] = self.mapComuni.filter(function (comune) {
                        return comune.sigla == provincia;
                    });
                    if (clearPf) {
                        self.capList[field] = [];
                        self.currentPf[field].comune = null;
                        self.currentPf[field].cap = null;
                    }
                } else if (provincia === 'EE') {
                    self.citiesList[field] = [];
                    self.capList[field] = [];
                    //self.raccoltaInfo.datiSocietari[field].stato = '';
                    self.raccoltaInfo.datiSocietari[field].stato = '';
                    console.log("GETCITIES - EE - ", self.raccoltaInfo.datiSocietari[field]);


                }

            }

            self.getCaps = function (field, comune) {
                var clearPf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (comune) {
                    if (!self.raccoltaInfo.datiSocietari[field] || self.raccoltaInfo.datiSocietari[field] && self.raccoltaInfo.datiSocietari[field].provincia != 'EE') {
                        self.capList[field] = self.mapComuni.find(function (el) {
                            return el.nome.toUpperCase() === comune.toUpperCase();
                        }) || [];
                        if (self.capList[field].cap) {
                            self.capList[field] = self.capList[field].cap;
                        }
                    }
                    if (clearPf) {
                        if (self.capList[field].length === 1) {
                            self.currentPf[field].cap = self.capList[field][0];
                        } else self.currentPf[field].cap = null;
                    } else {
                        if (self.raccoltaInfo.datiSocietari[field]) {
                            if (self.capList[field].length === 1) {
                                self.raccoltaInfo.datiSocietari[field].cap = self.capList[field][0];
                            } else {
                                if (self.capList[field].indexOf(self.raccoltaInfo.datiSocietari[field].cap) == -1) {
                                    self.raccoltaInfo.datiSocietari[field].cap = null;
                                }
                            }
                        }
                    }
                }

            }

            self.openDocumentModal = function () {
                $modalService.openModal('documentoRiconoscimento');

                self.datiDocumento = Object.assign({}, self.currentPf.documento);

                if (self.currentPf.documento.provincia) {
                    self.getCities('documentoIdentita', self.currentPf.documento.provincia);
                    if (self.datiDocumento.luogo) {
                        var luogo = self.citiesList.documentoIdentita.find(function (el) {
                            return el.nome.toUpperCase() == self.currentPf.documento.luogo.toUpperCase()
                        });
                        if (luogo) self.currentPf.documento.luogo = luogo;
                        else {
                            if (self.dropdown.stati) {
                                var nazione = self.dropdown.stati.find(function (naz) {
                                    return naz.name.toUpperCase() === self.currentPf.documento.luogo.toUpperCase();
                                });
                                if (nazione) self.currentPf.documento.luogo = nazione.name;
                            }
                        }
                    }
                }
                if (self.currentPf.documento.tipo) {
                    self.setDocNumRegex(self.currentPf.documento.tipo, self.currentPf);
                }
            }

            self.setDocNumRegex = function (doc, pf) {
                pf.documento.enteRilascio = self.dropdown.entiRilascio
                    .filter(function (ente) {
                        var docTypes = ente.description.split('|');
                        return docTypes.indexOf(doc) != -1;
                    })
                    .name;
                self.validationObj.regex.documentNumber = validationService.getDocTypeRegex(doc);

                switch (doc) {
                    case propMap['DOC_TYPE_CAE']:
                        pf.documento.provincia = 'EE';
                        break;
                    case propMap['DOC_TYPE_UCO']:
                        pf.documento.luogo = 'MIT-UCO';
                        break;
                    default:
                        break;
                }
            }

            self.getNsilDocument = function (type, cf) {
                var input = {
                    cf: cf,
                    type: type
                };
                verifyUniqueService.verifyDocument(input).then(function (response) {
                    if (response.success) {
                        if (response.document) {
                            self.documentFromNsil = response.document;

                            if (
                                response.document.dataRilascio &&
                                response.document.dataRilascio != "null"
                            ) {
                                self.documentFromNsil.dataRilascio = moment(
                                    parseInt(response.document.dataRilascio)
                                ).format("DD/MM/YYYY");
                            }
                            if (
                                response.document.dataScadenza &&
                                response.document.dataScadenza != "null"
                            ) {
                                self.documentFromNsil.dataScadenza = moment(
                                    parseInt(response.document.dataScadenza)
                                ).format("DD/MM/YYYY");

                                var daysDiff = moment
                                    .duration(
                                        moment(
                                            self.documentFromNsil.dataScadenza,
                                            "DD/MM/YYYY"
                                        ).diff(moment(self.today, "DD/MM/YYYY"))
                                    )
                                    .asDays();
                                if (daysDiff <= 0) {
                                    self.documentFromNsil = null;
                                }
                            }
                        } else {
                            self.documentFromNsil = null;
                        }
                        console.log("document from NSIL: ", response.document);
                    }
                });
            };

            self.verifyCardType = function () {
                if (self.currentPf.documento.tipo && self.currentPf.documento.numero) {

                    var isUnique = !self.raccoltaInfo.listaPf.some(function (pf) {
                        return pf.cf != self.currentPf.cf && pf.documento.tipo == self.currentPf.documento.tipo && pf.documento.numero == self.currentPf.documento.numero;
                    });

                    if (isUnique) {
                        self.forms.documentForm.documentNumber.$setValidity('unique', true);
                        self.forms.documentForm.documentNumber.$invalid = false;
                        self.forms.documentForm.documentNumber.$valid = true;

                    } else {
                        self.forms.documentForm.documentNumber.$invalid = true;
                        self.forms.documentForm.documentNumber.$valid = false;
                        self.forms.documentForm.documentNumber.$setValidity('unique', false);
                    }
                } else {
                    self.forms.documentForm.documentNumber.$setValidity('unique', true);
                    self.forms.documentForm.documentNumber.$invalid = false;
                    self.forms.documentForm.documentNumber.$valid = true;
                }
            }

            self.getEndDate = function (dataRilascio) {
                if (self.currentPf) {
                    var tipoDocumento = self.currentPf.documento.tipo;
                    var dataNascita = self.currentPf.datiNascita.data;

                    if (dataRilascio) {

                        var dataRilascio = moment(dataRilascio, 'DD/MM/YYYY');
                        var startYear = moment(dataRilascio).format('YYYY');
                        var startDay = moment(dataRilascio).format('DD');
                        var startMonth = moment(dataRilascio).format('MM');

                        var endDate = moment(dataRilascio).add(10, 'years').format('DD/MM/YYYY');

                        //console.log("Data Scadenza Futura: " + moment(endDate).format('DD/MM/YYYY'));

                        if (tipoDocumento === propMap['DOC_TYPE_CAI'] ||
                            tipoDocumento === propMap['DOC_TYPE_NCE'] ||
                            tipoDocumento === propMap['DOC_TYPE_CIE'] ||
                            tipoDocumento === propMap['DOC_TYPE_CAE']) {

                            var dataNascita = moment(dataNascita, 'DD/MM/YYYY');
                            var birthYear = moment(dataNascita).format('YYYY');;
                            var birthDay = moment(dataNascita).format('DD');
                            var birthMonth = moment(dataNascita).format('MM');

                            if (birthMonth == '02' && birthDay == '29') {
                                birthMonth = '03';
                                birthDay = '01';
                            }

                            var futureBirthDay = moment(birthDay + '/' + birthMonth + '/' + startYear, 'DD/MM/YYYY').add(10, 'years').format('DD/MM/YYYY');
                            //console.log("Compleanno Futuro: " + futureBirthDay);

                            var daysDiff = moment.duration(moment(endDate, 'DD/MM/YYYY').diff(moment(futureBirthDay, 'DD/MM/YYYY'))).asDays();

                            var expiryDate;
                            if (daysDiff <= 0) {
                                expiryDate = moment(futureBirthDay, 'DD/MM/YYYY').format('DD/MM/YYYY');
                            } else {
                                expiryDate = moment(birthDay + '/' + birthMonth + '/' + startYear, 'DD/MM/YYYY').add(11, 'years').format('DD/MM/YYYY');
                            }

                            if (self.forms && moment.duration(moment(self.currentPf.documento.dataScadenza, 'DD/MM/YYYY').diff(moment(expiryDate, 'DD/MM/YYYY'))).asDays() > 0) {

                                self.forms.documentForm.dataScadenza.$valid = false;
                            }
                            return expiryDate;
                        } else {
                            if (self.forms && moment.duration(moment(self.currentPf.documento.dataScadenza, 'DD/MM/YYYY').diff(moment(endDate, 'DD/MM/YYYY'))).asDays() > 0) {
                                self.forms.documentForm.dataScadenza.$valid = false;
                            }
                            return endDate;
                        }
                    } else {
                        return moment(self.today, 'DD/MM/YYYY').add(10, 'years').format('DD/MM/YYYY');
                    }
                }
                return moment(self.today, 'DD/MM/YYYY').add(10, 'years').format('DD/MM/YYYY');
            }

            self.canSavePfData = function (pf) {
                if (pf.cf && pf.nome && pf.cognome && pf.sesso && pf.datiNascita.data) {

                    var cfInfo = {
                        cf: {
                            value: pf.cf
                        },
                        nome: pf.nome,
                        cognome: pf.cognome,
                        sesso: {
                            value: pf.sesso.toUpperCase()
                        },
                        Giorno: {
                            value: pf.datiNascita.data.split('/')[0]
                        },
                        Mese: {
                            value: pf.datiNascita.data.split('/')[1]
                        },
                        Anno: {
                            value: pf.datiNascita.data.split('/')[2]
                        },
                        provincia: pf.datiNascita.provincia,
                        comune: pf.datiNascita.comune
                    };

                    var infoFirmatario = true;
                    var infoTitolare = true;
                    var isFirmatario = false;
                    var isTitolare = false;
                    var infoAnagrafiche = !!(pf.nome &&
                        pf.cognome &&
                        pf.sesso &&
                        pf.datiNascita.data &&
                        pf.datiNascita.provincia &&
                        pf.datiNascita.comune &&
                        pf.residenza.indirizzo &&
                        pf.residenza.numeroCivico &&
                        pf.residenza.provincia &&
                        pf.residenza.comune &&
                        pf.residenza.cap
                    );

                    var infoDocumento = !!(pf.documento.tipo &&
                        pf.documento.numero &&
                        pf.documento.enteRilascio &&
                        pf.documento.luogo &&
                        (pf.documento.tipo == propMap['DOC_TYPE_PAS'] || pf.documento.tipo == propMap['DOC_TYPE_CAE'] || !!pf.documento.provincia) &&
                        pf.documento.dataRilascio &&
                        pf.documento.dataScadenza
                    );

                    if (pf.titolare.selected) {
                        isTitolare = true;
                        if (pf.titolare.pep === 'y') {
                            infoTitolare = !!(pf.titolare.pep && pf.titolare.motivazione);
                        } else {
                            infoTitolare = !!(pf.titolare.pep);
                        }
                    }
                    if (pf.firmatario.selected) {
                        isFirmatario = true;
                        infoFirmatario = !!pf.firmatario.ruolo && pf.telefono && pf.email;

                        var digitalSign = self.raccoltaInfo.userPickedDigitalSignature;
                        if (digitalSign) {
                            infoFirmatario = infoFirmatario && self.warnings.digitalSignDocuments['imgDocFirmatario1'];
                        }

                    }
                    if (!cfChecker.validateCfFromInfo(cfInfo, self.dropdown.stati)) {
                        $('input[name="codiceFiscale"]').addClass('has-error');
                        self.warnings.errorMsg.cf = 'Il codice fiscale o i dati inseriti sono errati.';
                        return false;
                    } else {
                        $('input[name="codiceFiscale"]').removeClass('has-error');
                        self.warnings.errorMsg.cf = '';
                        if (isTitolare && !isFirmatario) {
                            if (infoAnagrafiche && infoDocumento && infoTitolare) {
                                return true;
                            }
                        }

                        return (isTitolare || isFirmatario) && infoAnagrafiche && infoDocumento && infoFirmatario && infoTitolare;
                    }
                } else return false;
            }

            self.changed = function (pf) {

                self.enableLoader = true;
                $rootScope.$broadcast("pageLoader", {
                    action: "OPEN"
                });

                var index = self.riUserF.listaPf.findIndex(function (el) {
                    return !!el.cf && el.cf == pf.cf || !!el.idEstero && el.idEstero == pf.idEstero;
                });
                //self.riUserF.listaPf.push(pf);
                /* if(pf.isEstero){
                    pf.cf= validationService.createCf(pf.nome, pf.cognome, pf.datiNascita.data, pf.sesso, pf.datiNascita.stato.value);
                } */
                if (index < 0 && (pf.cf || pf.idEstero)) {
                    self.riUserF.listaPf.push(pf);
                } else if (pf.cf || pf.idEstero) {
                    self.riUserF.listaPf.splice(index, 1, pf);
                }
                self.model.riUserF = self.riUserF;

                if (!pf.isOk) {
                    self.enableLoader = false;
                    if (pf.isEstero) {
                        $modalService.closeModal('censusPfEstero');
                        self.enableModalPfEstero = false;
                    } else {
                        $modalService.closeModal('censusPerson');
                    }

                    return;
                }

                pf.personalDocsComplete = pf.isOk;

                if (!self.isDigital) {


                    $instantService.updatePersonalActivity(self.appIlTransaction.id, Pf.build(pf))
                        .then(function (response) {
                            console.log(response)
                            self.checkOk();
                            $modalService.closeModal("censusPerson");
                            $("#footerInstant").css("z-index", "2");
                            $('.financial-leasing__footer').css("z-index", "2");
                            jQuery('.mCSB_scrollTools').css("z-index", "2");
                            self.enableModal = false;
                            $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE"
                            });

                        })
                        .catch(function (error) {
                            console.log(error);
                            self.riUserF.listaPf = self.riUserF.listaPf.map(function (element) {
                                if (element.cf == pf.cf) {
                                    element.isOk = false;
                                }
                                return element;
                            })
                            self.checkOk();
                            $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE"
                            });
                        })
                } else {
                    $financialApiService.updatePersonalActivityDigital(self.financialModel.leasingData.id, Pf.build(pf), self.isContractSignatureMap)
                        .then(function (response) {
                            self.enableLoader = false;
                            $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE"
                            });
                            if (!response.success) {
                                console.log(response)
                                self.riUserF.listaPf = self.riUserF.listaPf.map(function (element) {
                                    if (element.cf == pf.cf) {
                                        element.isOk = false;
                                    }
                                    return element;
                                })
                                pf.personalDocsComplete = false;
                            } else {
                                if (pf.isEstero) {
                                    self.enableModalPfEstero = false;
                                    $modalService.closeModal('censusPfEstero');
                                } else {
                                    self.enableModal = false;
                                    $modalService.closeModal('censusPerson');
                                }

                                self.checkOk();
                                $("#footerInstant").css("z-index", "2");
                                $('.financial-leasing__footer').css("z-index", "2");
                                jQuery('.mCSB_scrollTools').css("z-index", "2");
                                pf.personalDocsComplete = true;
                                if (self.financialModel.leasingData.preventivo.smallTicket && self.isContractSignatureMap) {
                                    callDraftInstance();
                                }
                            }
                            checkIfUserNotRule();
                            // chiamata effettuata per aggiornare le informazioni dell'invia in ARC una volta che si sono modificate le info dei singoli PF
                            if (self.isContractSignatureMap) {
                                callGetLinkPersonContract();
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.riUserF.listaPf = self.riUserF.listaPf.map(function (element) {
                                if (element.cf == pf.cf) {
                                    element.isOk = false;
                                }
                                return element;
                            })
                            self.checkOk();
                            self.enableLoader = false;
                            $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE"
                            });
                            pf.personalDocsComplete = false;
                            checkIfUserNotRule();
                        })
                }

            }

            self.checkOk = function () {
                var tmp = JSON.parse(JSON.stringify(self.model.riUserF));

                if (tmp.listaPf) {
                    tmp = tmp.listaPf;
                }

                if (self.isDigital) {
                    checkAllDataCompleted();
                    tmp = JSON.parse(JSON.stringify(self.model.riUserF));

                    if (tmp.listaPf) {
                        tmp = tmp.listaPf;
                    }
                    var isOkPf = tmp && tmp
                        .every(function (el) {
                            return el.isOk === true;
                        });
                    self.isPresentTitolare = tmp && tmp.some(function (elem) {
                        return elem && elem.titolare && elem.titolare.selected === true
                    })

                    self.isPresentFirmatario = tmp && tmp.some(function (elem) {
                        return elem && elem.firmatario && elem.firmatario.selected === true
                    })
                    var ruleIsSelected = tmp && tmp
                        .every(function (element) {
                            return element.notRule == false;
                        })
                    if ($portalService.isAra()) {

                        if (!self.isContractSignatureMap) {

                            if (ruleIsSelected && isOkPf && self.model && self.model.adeguataVerifica && self.model.adeguataVerifica.mandatoFiduciario && !!!self.listOfDisabledUser.length) {
                                self.individualsOk();
                                return;
                            } else if (((self.isPresentFirmatario)) &&
                                ruleIsSelected && isOkPf && !!!self.listOfDisabledUser.length) {

                                self.individualsOk();
                                return;

                            } else {

                                self.individualsNotOk();
                                return;

                            }
                        } else {
                            var testComponent = self.riUserF.listaPf
                                .every(function (element) {
                                    return element.personalDocsComplete == true;
                                })

                            if (testComponent) {
                                self.individualsOk();
                                return;
                            } else {
                                self.individualsNotOk();
                                return;
                            }
                        }

                    } else {
                        if (ruleIsSelected && isOkPf && self.model.adeguataVerifica.mandatoFiduciario) {
                            self.individualsOk();
                            return;
                        } else if (((self.isPresentFirmatario)) &&
                            ruleIsSelected && isOkPf) {

                            self.individualsOk();
                            return;

                        } else {

                            self.individualsNotOk();
                            return;

                        }
                    }

                }

                var isOkPf = tmp && tmp
                    .filter(function (user) {
                        return user.cf === self.dealerUser.identifier || (user.titolare.selected == true && user.firmatario.selected == false);
                    })
                    .every(function (el) {
                        return el.isOk === true;
                    });

                self.isPresentTitolare = tmp && tmp.some(function (elem) {
                    return elem && elem.titolare && elem.titolare.selected === true
                })

                self.isPresentFirmatario = tmp && tmp.some(function (elem) {
                    return elem && elem.firmatario && elem.firmatario.selected === true
                })

                self.isPresentPEP = tmp && tmp.some(function (elem) {
                    return elem && elem.titolare && elem.titolare.pep === 'Y'
                })

                var selectedFirmatarioOrTitolare = tmp
                    .some(function (element) {
                        return element.titolare.selected == false && element.firmatario.selected == false;
                    })

                if (((self.isPresentFirmatario)) &&
                    isOkPf &&
                    !selectedFirmatarioOrTitolare &&
                    !self.isPresentPEP &&
                    !self.raccoltaInfo.adeguataVerifica.mandatoFiduciario) {

                    self.individualsOk();

                } else {

                    self.individualsNotOk();

                }

            }

            var dealerUser = function () {

                if ($portalService.isAru()) {

                    $userService.getDealerUser()
                        .then(function (dealer) {
                            if (dealer) {
                                self.dealerUser = dealer;
                                self.checkOk();
                            }
                        });
                }

            }

            self.goBackModal = function (id) {
                $modalService.closeModal(id);
                self.enableModal = false;
                self.enableModalPfEstero = false;
                self.user = Pf.build();
                self.checkOk();
            }

            self.updateOrderTable = function (data, order) {

                if (self.riUserF.listaPf.length < 2) {
                    return;
                }

                self.filterTools.orderColumnName = data;
                if (order == 'DESC') {
                    self.filterTools.orderType = 'DESC';
                    self.riUserF.listaPf = self.riUserF.listaPf
                        .sort(function (a, b) {
                            if (a[data] > b[data]) {
                                return -1
                            } else {
                                return 1
                            }
                        })
                } else {
                    self.filterTools.orderType = 'ASC';
                    self.riUserF.listaPf = self.riUserF.listaPf
                        .sort(function (a, b) {
                            if (a[data] < b[data]) {
                                return -1
                            } else {
                                return 1
                            }
                        })

                }


            }

            var getStati = function () {

                self.nationsList = $rootScope.nazioniEstere.filter(
                    function (elem) {
                        return elem.name != "ITALIA";
                    }
                );

            };

            var getWizardMap = function (viewIndex) {
                return $rootScope.wizardMap
                    .find(function (element) {
                        return element.index == viewIndex
                    }).viewName
            }

            self.handleChangeModel = function (warranties) {
                self.supportModel.totalWarrantiesAmount = 0;
                warranties.forEach(function (element) {
                    self.supportModel.totalWarrantiesAmount =
                        parseFloat(self.supportModel.totalWarrantiesAmount) + parseFloat(element.importoInizialeGaranzia)
                });
                populateGuarSelectedList();
            }

            var populateGuarSelectedList = function () {
                //Se all'interno della garanzia è stato aggiunto un garante,
                //non è possibile cancellare il garante dalla lista
                self.garantiSelectedList = [];
                self.guaranteeToDisable = [];
                self.firmatariSelectedList = [];
                if (self.financialModel.leasingData.preventivo.garanzie.length > 0) {
                    self.financialModel.leasingData.preventivo.garanzie.forEach(function (garanzia) {
                        garanzia.listaGaranti.forEach(function (el) {
                            if (el.garante.selected) {
                                self.garantiSelectedList.push(el);
                                self.checkDisabledPf(el.cfGarante);
                            }
                            if (el.firmatario.selected) {
                                self.firmatariSelectedList.push(el);
                                self.checkDisabledFir(el.firmatario);
                            }
                        });
                    });
                } else {
                    //se cancello tutte le garanzie, verifico se è presente
                    //un firmatario per non sbloccare il lucchetto
                    self.financialModel.financialCustomer.metadata.aziendeGaranti.forEach(function (element) {
                        if (element.cfFirmatario != null) {
                            self.firmatariSelectedList.push({
                                "cfFirmatario": element.cfFirmatario,
                                selected: true
                            });
                            self.checkDisabledFir(element.cfFirmatario);
                        }
                    });
                }

                self.guaranteeToDisable = self.garantiSelectedList;

            }

            self.checkDisabledPf = function (cf) {
                return self.garantiSelectedList && self.garantiSelectedList.some(function (element) {
                    return element.cfGarante == cf
                })
            }

            self.checkDisabledFir = function (cf) {
                return self.firmatariSelectedList && self.firmatariSelectedList.some(function (element) {
                    return element.cfFirmatario == cf
                })
            }

            var searchOfusersDisabled = function (user, fromAddDeleteUser, isDelete) {

                if (fromAddDeleteUser) {
                    var elementIsPresent = self.listOfDisabledUser
                        .findIndex(function (element) {
                            return element.cf == user[0].cf;
                        })
                    if (elementIsPresent >= 0 && isDelete) {
                        self.listOfDisabledUser.splice(elementIsPresent, 1)

                    } else if (elementIsPresent < 0) {
                        self.listOfDisabledUser = self.listOfDisabledUser.concat(user
                            .filter(function (element) {
                                return element.deleted == true;
                            }));
                    }
                } else {
                    self.listOfDisabledUser = self.listOfDisabledUser.concat(
                        user.filter(function (element) {
                            if (element) {
                                return element.deleted == true;
                            }

                        }));
                }

                if (self.inPurgatory.length >= 2) {
                    var oldValue = self.inPurgatory.shift();
                    var elementIsAdded = self.model.riUserF.listaPf
                        .findIndex(function (element) {
                            return element.cf == oldValue;
                        })
                    if (elementIsAdded < 0) {
                        self.listOfDisabledUser = self.listOfDisabledUser
                            .filter(function (element) {
                                return element.cf != oldValue;
                            })
                    }
                }

                if (self.listOfDisabledUser.length) {
                    self.enableMexUsersDisabled = true;
                } else {
                    self.enableMexUsersDisabled = false;
                }
                self.checkOk();
            }

            self.checkFirmatario = function (listaAziende) {
                if (listaAziende && listaAziende.length > 0) {
                    listaAziende.forEach(function (el) {
                        if (el.cfFirmatario) {
                            var cfIsPresent = self.firmatariSelectedList && self.firmatariSelectedList.some(function (element) {
                                return element.cfFirmatario == el.cfFirmatario
                            })
                            if (!cfIsPresent) {
                                self.firmatariSelectedList.push(el);
                                self.checkDisabledFir(el.cfFirmatario);
                            }
                        } else {
                            self.checkDisabledFir(null);
                        }
                    });
                } else {
                    self.firmatariSelectedList = listaAziende;
                    self.checkDisabledFir();
                }
            }

            var checkAllDataCompleted = function () {
                self.riUserF.listaPf
                    .forEach(function (element, index) {
                        if (element && element.firmatario && !element.firmatario.selected && element.titolare && element.titolare.selected) {
                            if (self.financialModel.leasingData.preventivo.firmaDigitale && !self.financialModel.leasingData.preventivo.firmaDigitaleEsterna) {
                                if ($portalService.isAru()) {
                                    if (element.isEstero) {

                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo

                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {

                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)
                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)
                                    }


                                } else {
                                    if (element.isEstero) {
                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo


                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)

                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)
                                    }
                                }
                            } else {
                                if ($portalService.isAru()) {
                                    if (element.isEstero) {
                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo

                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)
                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)
                                    }


                                } else {
                                    if (element.isEstero) {
                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo


                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)

                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            ((!!element.documento &&
                                                !!element.documento.dataRilascio &&
                                                !!element.documento.dataScadenza &&
                                                !!element.documento.enteRilascio.name &&
                                                !!element.documento.numero &&
                                                !!element.documento.provincia &&
                                                !!element.documento.tipo &&
                                                (!!element.documento.luogo || !!element.documento.luogoEsteso.nome)) || (self.financialModel.leasingData.preventivo.smallTicket && !self.isContractSignatureMap)) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            checkCongrCogNomeCF(element)
                                    }
                                }

                            }
                        } else if (element && element.firmatario && element.firmatario.selected) {
                            if (self.financialModel.leasingData.preventivo.firmaDigitale && !self.financialModel.leasingData.preventivo.firmaDigitaleEsterna) {
                                if ($portalService.isAru()) {
                                    if (element.isEstero) {

                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            !!element.telefono &&
                                            !!element.email

                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {

                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            !!element.telefono &&
                                            !!element.email &&
                                            checkCongrCogNomeCF(element)
                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            !!element.telefono &&
                                            !!element.email &&
                                            checkCongrCogNomeCF(element)
                                    }


                                } else {
                                    if (element.isEstero) {
                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            !!element.telefono &&
                                            !!element.email


                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            !!element.telefono &&
                                            !!element.email &&
                                            checkCongrCogNomeCF(element)

                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            !!element.telefono &&
                                            !!element.email &&
                                            checkCongrCogNomeCF(element)
                                    }
                                }
                            } else {
                                if ($portalService.isAru()) {
                                    if (element.isEstero) {
                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo

                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            checkCongrCogNomeCF(element)
                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            checkCongrCogNomeCF(element)
                                    }


                                } else {
                                    if (element.isEstero) {
                                        element.isOk = !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo


                                    } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            !!element.datiNascita.stato.value &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            checkCongrCogNomeCF(element)

                                    } else {
                                        element.isOk = !!element.cf &&
                                            !!element.nome &&
                                            !!element.cognome &&
                                            !!element.sesso &&
                                            !!element.documento &&
                                            !!element.documento.dataRilascio &&
                                            !!element.documento.dataScadenza &&
                                            !!element.documento.enteRilascio.name &&
                                            !!element.documento.numero &&
                                            !!element.documento.provincia &&
                                            !!element.documento.tipo &&
                                            (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                            (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                            !!element.datiNascita.data &&
                                            !!element.datiNascita.provincia &&
                                            !!element.residenza.cap &&
                                            (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                            !!element.residenza.numeroCivico &&
                                            !!element.residenza.provincia &&
                                            !!element.residenza.indirizzo &&
                                            !!element.firmatario.ruolo &&
                                            checkCongrCogNomeCF(element)
                                    }
                                }

                            }
                        } else if (element) {
                            element.isOk = controlloIesimoPf(element);

                        }

                        element.personalDocsComplete = element.isOk;

                    })
            }

            var controlloIesimoPf = function (pf) {
                if ($portalService.isAru()) {
                    if (pf.isEstero) {
                        return (
                            !!pf.nome &&
                            !!pf.cognome &&
                            !!pf.sesso &&
                            !!pf.documento &&
                            !!pf.documento.dataRilascio &&
                            !!pf.documento.dataScadenza &&
                            !!pf.documento.enteRilascio.name &&
                            !!pf.documento.numero &&
                            !!pf.documento.provincia &&
                            !!pf.documento.tipo &&
                            (!!pf.documento.statoEsteso || !!pf.documento.statoEsteso.name) &&
                            !!pf.datiNascita.stato.value &&
                            !!pf.datiNascita.data &&
                            !!pf.datiNascita.provincia &&
                            !!pf.residenza.cap &&
                            (!!pf.residenza.statoEsteso || !!pf.residenza.statoEsteso.name) &&
                            !!pf.residenza.numeroCivico &&
                            !!pf.residenza.provincia &&
                            !!pf.residenza.indirizzo &&
                            !!pf.titolare
                        )
                    } else if (!pf.isEstero && pf.cf.substr(11, 1).toUpperCase() == 'Z') {
                        return (
                            !!pf.cf &&
                            !!pf.nome &&
                            !!pf.cognome &&
                            !!pf.sesso &&
                            !!pf.documento &&
                            !!pf.documento.dataRilascio &&
                            !!pf.documento.dataScadenza &&
                            !!pf.documento.enteRilascio.name &&
                            !!pf.documento.numero &&
                            !!pf.documento.provincia &&
                            !!pf.documento.tipo &&
                            (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                            !!pf.datiNascita.stato.value &&
                            !!pf.datiNascita.data &&
                            !!pf.datiNascita.provincia &&
                            !!pf.residenza.cap &&
                            (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                            !!pf.residenza.numeroCivico &&
                            !!pf.residenza.provincia &&
                            !!pf.residenza.indirizzo &&
                            !!pf.titolare &&
                            checkCongrCogNomeCF(pf)
                        )
                    } else {
                        return (
                            !!pf.cf &&
                            !!pf.nome &&
                            !!pf.cognome &&
                            !!pf.sesso &&
                            !!pf.documento &&
                            !!pf.documento.dataRilascio &&
                            !!pf.documento.dataScadenza &&
                            !!pf.documento.enteRilascio.name &&
                            !!pf.documento.numero &&
                            !!pf.documento.provincia &&
                            !!pf.documento.tipo &&
                            (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                            (!!pf.datiNascita.comune || !!pf.datiNascita.luogoEsteso.nome) &&
                            !!pf.datiNascita.data &&
                            !!pf.datiNascita.provincia &&
                            !!pf.residenza.cap &&
                            (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                            !!pf.residenza.numeroCivico &&
                            !!pf.residenza.provincia &&
                            !!pf.residenza.indirizzo &&
                            !!pf.titolare &&
                            checkCongrCogNomeCF(pf)
                        )
                    }

                } else {
                    if (pf.isEstero) {
                        return (
                            !!pf.nome &&
                            !!pf.cognome &&
                            !!pf.sesso &&
                            !!pf.documento &&
                            !!pf.documento.dataRilascio &&
                            !!pf.documento.dataScadenza &&
                            !!pf.documento.enteRilascio.name &&
                            !!pf.documento.numero &&
                            !!pf.documento.provincia &&
                            !!pf.documento.tipo &&
                            (!!pf.documento.statoEsteso || !!pf.documento.statoEsteso.name) &&
                            !!pf.datiNascita.stato.value &&
                            !!pf.datiNascita.data &&
                            !!pf.datiNascita.provincia &&
                            !!pf.residenza.cap &&
                            (!!pf.residenza.statoEsteso || !!pf.residenza.statoEsteso.name) &&
                            !!pf.residenza.numeroCivico &&
                            !!pf.residenza.provincia &&
                            !!pf.residenza.indirizzo &&
                            !!pf.titolare
                        )
                    } else if (!pf.isEstero && pf.cf.substr(11, 1).toUpperCase() == 'Z') {
                        return (
                            !!pf.cf &&
                            !!pf.nome &&
                            !!pf.cognome &&
                            !!pf.sesso &&
                            !!pf.documento &&
                            !!pf.documento.dataRilascio &&
                            !!pf.documento.dataScadenza &&
                            !!pf.documento.enteRilascio.name &&
                            !!pf.documento.numero &&
                            !!pf.documento.provincia &&
                            !!pf.documento.tipo &&
                            (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                            !!pf.datiNascita.stato.value &&
                            !!pf.datiNascita.data &&
                            !!pf.datiNascita.provincia &&
                            !!pf.residenza.cap &&
                            (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                            !!pf.residenza.numeroCivico &&
                            !!pf.residenza.provincia &&
                            !!pf.residenza.indirizzo &&
                            !!pf.titolare &&
                            checkCongrCogNomeCF(pf)
                        )
                    } else {
                        return (
                            !!pf.cf &&
                            !!pf.nome &&
                            !!pf.cognome &&
                            !!pf.sesso &&
                            !!pf.documento &&
                            !!pf.documento.dataRilascio &&
                            !!pf.documento.dataScadenza &&
                            !!pf.documento.enteRilascio.name &&
                            !!pf.documento.numero &&
                            !!pf.documento.provincia &&
                            !!pf.documento.tipo &&
                            (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                            (!!pf.datiNascita.comune || !!pf.datiNascita.luogoEsteso.nome) &&
                            !!pf.datiNascita.data &&
                            !!pf.datiNascita.provincia &&
                            !!pf.residenza.cap &&
                            (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                            !!pf.residenza.numeroCivico &&
                            !!pf.residenza.provincia &&
                            !!pf.residenza.indirizzo &&
                            !!pf.titolare &&
                            checkCongrCogNomeCF(pf)
                        )

                    }
                }

            }

            var checkIfUserNotRule = function () {
                if (!self.model.riUserF.listaPf.length) {
                    self.model.riUserF.listaPf = self.riUserF.listaPf;
                }
                self.model.riUserF.listaPf.forEach(function (element) {
                    if (!element.titolare.selected && !element.firmatario.selected && !element.garante.selected) {
                        element.notRule = true;
                    } else {
                        element.notRule = false;
                    }
                })
                self.riUserF.listaPf = self.model.riUserF.listaPf
                self.checkOk();
            }

            self.searchPfFromNdg = function () {
                self.openSectionUpgradePf = false;
                self.searching = true;
                if (self.userAlreadyAdded(self.searchObj.ndg.toUpperCase(), true)) {
                    return
                }

                self.PFresultsShown = true;
                $financialApiService.searchSubject(self.searchObj.ndg)
                    .then(function (pf) {

                        if (pf && pf.metadata && pf.metadata.riUserF) {
                            pf.metadata.riUserF.titolare.selected = false;
                            pf.metadata.riUserF.firmatario.selected = false;

                            self.tempPerson = Pf.build(pf.metadata.riUserF);

                            if (self.tempPerson && self.tempPerson.isEstero) {
                                self.tempPerson.datiNascita.stato = self.tempPerson.datiNascita &&
                                    self.tempPerson.datiNascita.comune &&
                                    self.nationsList
                                        .find(function (element) {
                                            return element.name.toUpperCase() == self.tempPerson.datiNascita.comune
                                        })
                                self.tempPerson.residenza.statoEsteso = self.tempPerson.residenza &&
                                    self.tempPerson.residenza.comune &&
                                    self.nationsList
                                        .find(function (element) {
                                            return element.name.toUpperCase() == self.tempPerson.residenza.comune
                                        })

                                self.tempPerson.residenza.stato = self.tempPerson.residenza &&
                                    self.tempPerson.residenza.comune &&
                                    self.nationsList
                                        .find(function (element) {
                                            return element.name.toUpperCase() == self.tempPerson.residenza.comune
                                        })

                                var objectNation = self.nationsList
                                    .find(function (element) {
                                        return element.name.toUpperCase() == self.tempPerson.datiNascita.comune.toUpperCase();
                                    })
                                self.tempPerson.sesso = new Date().getSeconds() % 2 == 0 ? 'm' : 'f';
                                self.tempPerson.cf = validationService.createCf(self.tempPerson.nome, self.tempPerson.cognome, self.tempPerson.datiNascita.data, self.tempPerson.sesso, objectNation.value);
                            }
                            self.PFresultsShown = true;

                            self.documentFromNsil = null;
                            self.inPurgatory.push(self.tempPerson.cf);
                            var listOfUser = [self.tempPerson];
                            searchOfusersDisabled(listOfUser);
                            self.emptyTemp = false;
                        } else {
                            self.searching = true;
                            self.emptyTemp = true;
                            $rootScope.$broadcast("addAlert", {
                                text: "ERROR_WF_FUNCTIONAL",
                                message: "NDG associato a persona giuridica: " + pf.metadata.riUserG.ragioneSociale
                            })

                        }

                    })
                    .catch(function (error) {
                        console.log('error', error);
                    })
                    .finally(function () {
                        self.searching = false;

                    })

            }

            self.addPfEstero = function () {

                self.user = Pf.build({
                    isEstero: true,
                    datiNascita: {
                        provincia: 'EE',
                        stato: {
                            value: null,
                            name: null,
                            description: null
                        }
                    },
                    residenza: {
                        provincia: 'EE'
                    },
                    documento: {
                        statoEsteso: {
                            value: null,
                            name: null,
                            description: null
                        }
                    },
                    domicilio: { 
                        stato: {
                            value: null,
                            name: null,
                            description: null
                        },
                        statoEsteso: {
                            value: null,
                            name: null,
                            description: null
                        }
                    }
                });
                self.disableButtonAddEstero = true;
                self.openSectionUpgradePf = true;
            }

            self.completaPfEstero = function () {
                self.enableModalPfEstero = true;
                self.user.idEstero = validationService.createCf(self.user.nome, self.user.cognome, self.user.datiNascita.data, self.user.sesso, self.user.datiNascita.stato.value);
                $timeout(function () {
                    $("#footerInstant").css("z-index", "-1");
                    $('.financial-leasing__footer').css("z-index", "-1");
                    $modalService.openModal("censusPfEstero");
                    self.disableButtonAddEstero = false;
                    self.openSectionUpgradePf = false;
                }, 100)
            }

            self.setDate = function (name, value) {
                self.user.datiNascita.data = value;
            }

            self.validateAccordionAziendaGarante = function (value) {

                if (value) {
                    self.individualsOk();

                } else {
                    self.individualsNotOk();
                }

            }

            var callGetLinkPersonContract = function () {
                var allPfIsOk = self.riUserF.listaPf.every(function (element) {
                    return element.personalDocsComplete
                })

                if (allPfIsOk) {
                    var loaderSigner = false;

                    self.riUserF && self.riUserF.listaPf && getSignatureContract(loaderSigner, self.riUserF.listaPf);
                    self.checkOk();
                }
            }

            var controlIfUserFromAdv = function (listaPf) {
                listaPf.forEach(function (element, index) {
                    var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                    if (!element.isEstero) {
                        self.model.riUserF.listaPf[index] = Pf.build(element).setDefaultPfValues(self.nationsList, comuni);
                    } else {
                        self.model.riUserF.listaPf[index].idEstero = validationService.createCf(element.nome, element.cognome, element.datiNascita.data, element.sesso, element.datiNascita.stato.value);
                    }
                    if (!!element.datiNascita.stato && !!!element.datiNascita.stato.value && !!element.datiNascita.stato.name) {
                        self.model.riUserF.listaPf[index].datiNascita.stato = self.nationsList.find(nation => element.datiNascita.stato.name.toUpperCase() == nation.name.toUpperCase());
                    }
                })
            }
            var checkCongrCogNomeCF = function (element) {
                var codCat;
                var testCongNomeCogCF = false;
                if (element && element.datiNascita && (element.datiNascita.provincia == 'SE' || element.datiNascita.provincia == 'EE') && element.datiNascita.stato.name) {
                    codCat = element.datiNascita.stato.value;
                } else if (element && element.datiNascita &&
                    element.datiNascita.luogoEsteso &&
                    element.datiNascita.luogoEsteso.nome) {
                    var comuniCompleti = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                    var tempCodCat = comuniCompleti
                        .filter(function (comune) {
                            return comune.nome.toUpperCase() == element.datiNascita.luogoEsteso.nome.toUpperCase()
                        })[0].codiceCatastale;
                    codCat = element.datiNascita.luogoEsteso.codiceCatastale ? element.datiNascita.luogoEsteso.codiceCatastale : tempCodCat;
                }
                if (!codCat) {
                    testCongNomeCogCF = false;
                } else {
                    testCongNomeCogCF = validationService.checkCfWithFieds(
                        element.cf,
                        element.nome,
                        element.cognome,
                        element.datiNascita.data,
                        element.sesso,
                        codCat
                    ).value;

                }
                return testCongNomeCogCF;
            }

            var getListaEntiRilascio = function () {
                $typeDomainService
                    .getDomainSet("RI_DROPDOWN_DOMAINS", "AUTHORITY_TYPE")
                    .then(function (response) {
                        self.listaEntiRilascio = response.domainList;
                    });
            }

            var callDraftInstance = function () {
                var onlyLocal = true;
                var type = "WF_DIGITAL";
                $workflowService
                    .suspendInstance(self.financialModel, type, onlyLocal, self.financialModel.taskFiliale)
                    .then(function (success) {
                    })
                    .catch(function (err) {
                        console.log("suspend instance failed! Error cause was: " + err);

                    });

            }

            self.closeSectionUpdatePf = function () {
                self.disableButtonAddEstero = false;
                self.openSectionUpgradePf = false;

            }
        }
    });